import { cloneElement, forwardRef } from "react";
import { mergeRefs } from "../../common/utils/merge-refs";
import { A11yHighlight } from "../a11y-highlight";
import { A11yChildProps } from "./types";

export const A11yChild = forwardRef<HTMLElement, A11yChildProps>(
  ({ hasA11yFocus, children, className, a11yChildRef }, ref) => {
    const mergedRefs = mergeRefs(a11yChildRef, ref);

    return (
      <A11yHighlight hasA11yFocus={hasA11yFocus} className={className}>
        {cloneElement(children, {
          ...children.props,
          tabIndex: -1,
          ref: mergedRefs,
        })}
      </A11yHighlight>
    );
  }
);
